import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

export const cmsAuthStart = () => {
  return {
    type: actionTypes.CMS_AUTH_START,
  };
};

export const cmsAuthSuccess = (auth) => {
  return {
    auth,
    type: actionTypes.CMS_AUTH_SUCCESS,
  };
};

export const cmsAuthFailed = (err) => {
  return {
    err,
    type: actionTypes.CMS_AUTH_FAILED,
  };
};

export const onCmsAuth = (credentials) => {
  return async (dispatch) => {
    await dispatch(cmsAuthStart());

    try {
      const authentication = await axios.post(`${config.login}`, credentials);
      await dispatch(cmsAuthSuccess(authentication.data.data));
    } catch (e) {
      await dispatch(cmsAuthFailed());
    }
  };
};

const cmsAuthLogout = () => {
  return {
    type: actionTypes.CMS_AUTH_LOGOUT,
  };
};

export const onAuthLogout = () => {
  return async (dispatch) => {
    await dispatch(cmsAuthLogout());
  };
};
